import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENV_CONFIG, SourceType } from '@libs/vc-core-lib';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SourceService {
    private readonly _serviceBaseUrl = 'source';

    private readonly _environment = inject(ENV_CONFIG);
    private readonly _httpClient = inject(HttpClient);

    public getAll(): Observable<Record<SourceType, string[]>> {
        return this._httpClient.get<Record<SourceType, string[]>>(
            `${this._environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this._serviceBaseUrl}/map`
        );
    }
}
